var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortList = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7499 6H6.75C6.33579 6 6 5.66421 6 5.25C6 4.83579 6.33579 4.5 6.75 4.5L21.7499 4.5C22.1641 4.5 22.4999 4.83579 22.4999 5.25C22.4999 5.66421 22.1641 6 21.7499 6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.00012 11.25C6.00012 10.8358 6.33591 10.5 6.75012 10.5H21.75C22.1642 10.5 22.5 10.8358 22.5 11.25C22.5 11.6642 22.1642 12 21.75 12H6.75012C6.33591 12 6.00012 11.6642 6.00012 11.25Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 17.25C6 16.8358 6.33579 16.5 6.75 16.5H21.7499C22.1641 16.5 22.4999 16.8358 22.4999 17.25C22.4999 17.6642 22.1641 18 21.7499 18H6.75C6.33579 18 6 17.6642 6 17.25Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M3 5.25C3 5.66421 2.66421 6 2.25 6C1.83579 6 1.5 5.66421 1.5 5.25C1.5 4.83579 1.83579 4.5 2.25 4.5C2.66421 4.5 3 4.83579 3 5.25Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M3 11.25C3 11.6642 2.66421 12 2.25 12C1.83579 12 1.5 11.6642 1.5 11.25C1.5 10.8358 1.83579 10.5 2.25 10.5C2.66421 10.5 3 10.8358 3 11.25Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M3 17.25C3 17.6642 2.66421 18 2.25 18C1.83579 18 1.5 17.6642 1.5 17.25C1.5 16.8358 1.83579 16.5 2.25 16.5C2.66421 16.5 3 16.8358 3 17.25Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-list.da6adf531ad039fb8af60c4fec4c77c6.svg";